// extracted by mini-css-extract-plugin
export default {"container":"SimpleFeedbackList_container__dGMfz","correct":"SimpleFeedbackList_correct__fbIr3","incorrect":"SimpleFeedbackList_incorrect__8wwdO"};